import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TableContainer } from '../Reusable/TableContainer';
import { HeaderTable } from '../../enums/ProductEnums';
import {
  createProduct,
  deleteErrorProduct,
  deleteProduct,
  updateProduct,
  updateProductWithLogo,
  findProductByIdWithLogo,
} from '../../actions/product';
import { findAllProductCategorys } from '../../actions/productCategory';
import ProductTable from '../Product/ProductTable';
import ModalForAddProduct from '../Product/ModalForAddProduct';

const ProductContainer = () => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);

  const productReducer = useSelector((state) => state.product);
  const productCategoryReducer = useSelector((state) => state.productCategory);

  const showModal = (e) => {
    setShow(true);
  };

  const handleAdd = (product) => {
    dispatch(createProduct(product, handlePreviewClose));
  };

  useEffect(() => {
    dispatch(findAllProductCategorys());
  }, []);

  const handlePreviewClose = () => {
    setShow(false);
    clearValidationErrors();
  };

  const isModalOpened = (show) => {
    return show;
  };

  const clearValidationErrors = () => {
    dispatch(deleteErrorProduct());
  };

  return (
    <>
      <TableContainer
        cardTitle={HeaderTable.titleForProductTable}
        showModal={showModal}
        fullWidth
      >
        <ProductTable
          deleteProduct={deleteProduct}
          updateProduct={updateProduct}
          updateProductWithLogo={updateProductWithLogo}
          findProductByIdWithLogo={findProductByIdWithLogo}
          createProduct={createProduct}
          isModalOpened={isModalOpened}
          dispatch={dispatch}
          productReducer={productReducer}
          productCategoryReducer={productCategoryReducer}
          clearValidationErrors={clearValidationErrors}
        />
      </TableContainer>
      {show && (
        <ModalForAddProduct
          handleAdd={handleAdd}
          handleClose={handlePreviewClose}
          show={show}
          productReducer={productReducer}
          productCategoryReducer={productCategoryReducer}
        />
      )}
    </>
  );
};

export default ProductContainer;
